const validators = {};

export default validators;



// WEBPACK FOOTER //
// ./src/modules/registration/validators/action-validators.js